import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f6d0292"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-settings-weeek-page__tabs" }
const _hoisted_2 = { class: "project-settings-weeek-page__count-elements" }
const _hoisted_3 = { class: "project-settings-weeek-page__count-elements" }
const _hoisted_4 = { class: "project-settings-weeek-page__count-elements" }
const _hoisted_5 = { class: "project-settings-weeek-page__count-elements" }
const _hoisted_6 = {
  key: 0,
  class: "project-settings-weeek-page__controllers"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-settings-weeek-page__modal-content" }, " Если выйти сейчас, данные не сохранятся ", -1))

import {
  PopoverColorEnum,
  Tab,
  Tabs,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPopover,
} from "tir-components";
import { KeyIcon, PlusIcon } from "tir-style-system/icons/outline";
import { computed, onBeforeMount, onMounted, PropType, ref, watch } from "vue";
import { RouterView, useRouter } from "vue-router";
import { WeeekTabsEnum } from "./enums";
import { AdapterService } from "./adapter";
import { GetAttributeOptionsResponseItem, WeeekDataModel } from "@/models";
import {
  UpsertAttributesOptionsRequestItem,
  WeeekOptionsUpsertPrioritiesRequest,
  WeeekOptionsUpsertStatusesRequest,
  WeeekOptionsUpsertTagsRequest,
} from "./models";
import UpsertTagAttributeOptionsRequestItem from "@/api/Weeek/dataSource/api/project-manager/weeek/i-services/models/request/UpsertTagAttributeOptionsRequestItem";
import GetAttributeTagOptionsResponseItem from "@/api/Weeek/dataSource/api/project-manager/weeek/i-services/models/response/GetAttributeTagOptionsResponseItem";
import { TagModel } from "@/components/task-forms/models";

/**Роутер */

export default /*#__PURE__*/_defineComponent({
  __name: 'project-settings-weeek-page',
  props: {
  /**апи ключ */
  apiKey: { type: String },
  /**id проекта */
  projectId: { type: Number },
  /**Привязан ли токен */
  isTokenLinked: { type: Boolean },
  /**Данные weeek */
  dataWeeek: { type: Object as PropType<WeeekDataModel> },
  /**Есть ли изменения в массиве статусов Weeek */
  changeDataWeeek: { type: Boolean },
  /**Теги проекта ПМ */
  tagsProjectPm: { type: Array as PropType<TagModel[]> },
},
  emits: ["updateApiKey", "updateProjectSettings", "updateOriginalDataWeeek", "updateList", "searchTags"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
/**Адаптер */
const adapter = new AdapterService();

/**Параметры */

/**События */


/**Состояние таба */
const stateTabs = ref();
/**Видимость модалки */
const isVisibleModal = ref(false);
/**Выйти из модалки с переходом на другую вкладку */
const desiredRoute = ref();
/**Выйти из модалки */
const isExitModal = ref(false);
/**Загрузка */
const isLoading = ref(false);

router.beforeEach((to, from, next) => {
  if (props.changeDataWeeek && !isVisibleModal.value && !isExitModal.value) {
    isVisibleModal.value = true;
    const currentTab = Object.values(WeeekTabsEnum).find((tab) => tab === from.name);
    stateTabs.value = currentTab;
    desiredRoute.value = to;
    next(false);
  } else {
    isExitModal.value = false;
    next();
  }
});

/**При вмонтировании компонента */
onMounted(async () => {
  stateTabs.value = router.currentRoute.value.name;
});

/**Отключить модалку */
const hideModal = () => {
  isVisibleModal.value = false;
};
/**Переход по желаемому пути */
const goDesiredRoute = () => {
  isExitModal.value = true;
  isVisibleModal.value = false;
  const currentTab = Object.values(WeeekTabsEnum).find((tab) => tab === desiredRoute.value.name);
  stateTabs.value = currentTab;
  emit("updateList");
  router.push({ name: desiredRoute.value.name });
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    "add",
    new TirPmNotificationModel({
      title: message,
      type: isError ? "error" : "success",
      group: "general",
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Добавление/удаление/изменение сопоставления статусов */
const upsertStatusesWeeek = async () => {
  const response = await adapter.upsertStatusesWeeek(
    new WeeekOptionsUpsertStatusesRequest({
      ProjectId: props.projectId,
      Attributes: props.dataWeeek.StatusesWeeek.map(
        (item) => new GetAttributeOptionsResponseItem(item),
      ),
    }),
  );
  if (response.IsSuccess) {
    emit("updateOriginalDataWeeek");
    addNotification("Данные сохранены");
  }
};
/**Добавление/удаление/изменение сопоставления приоритетов */
const upsertPrioritiesAsync = async () => {
  const response = await adapter.upsertPrioritiesAsync(
    new WeeekOptionsUpsertPrioritiesRequest({
      ProjectId: props.projectId,
      Attributes: props.dataWeeek.PrioritiesWeeek.map(
        (item) => new GetAttributeOptionsResponseItem(item),
      ),
    }),
  );
  if (response.IsSuccess) {
    emit("updateOriginalDataWeeek");
    addNotification("Данные сохранены");
  }
};
/**Добавление/удаление/изменение сопоставления типов */
const upsertTypesAsync = async () => {
  const response = await adapter.upsertTypesAsync(
    new WeeekOptionsUpsertPrioritiesRequest({
      ProjectId: props.projectId,
      Attributes: props.dataWeeek.TypesWeeek.map(
        (item) => new GetAttributeOptionsResponseItem(item),
      ),
    }),
  );
  if (response.IsSuccess) {
    emit("updateOriginalDataWeeek");
    addNotification("Данные сохранены");
  }
};
/**Добавление/удаление/изменение сопоставления тегов */
const upsertTagsAsync = async () => {
  const response = await adapter.upsertTagsAsync(
    new WeeekOptionsUpsertTagsRequest({
      ProjectId: props.projectId,
      Attributes: props.dataWeeek.TagsWeeek.map(
        (item) => new UpsertTagAttributeOptionsRequestItem(item),
      ),
    }),
  );
  if (response.IsSuccess) {
    emit("updateOriginalDataWeeek");
    addNotification("Данные сохранены");
  }
};
/**Добавить сопоставление статусов */
const addStatusesWeeek = async () => {
  props.dataWeeek.StatusesWeeek.push(
    new GetAttributeOptionsResponseItem({
      Id: null,
      WeeekValue: "",
      PmValue: "",
    }),
  );
};
/**Добавить сопоставление приоритетов */
const addPrioritiesWeeek = async () => {
  props.dataWeeek.PrioritiesWeeek.push(
    new GetAttributeOptionsResponseItem({
      Id: null,
      WeeekValue: "",
      PmValue: "",
    }),
  );
};
/**Добавить сопоставление типов */
const addTypesWeeek = async () => {
  props.dataWeeek.TypesWeeek.push(
    new GetAttributeOptionsResponseItem({
      Id: null,
      WeeekValue: "",
      PmValue: "",
    }),
  );
};
/**Добавить сопоставление тегов */
const addTagsWeeek = async () => {
  props.dataWeeek.TagsWeeek.push(
    new GetAttributeTagOptionsResponseItem({
      TagId: null,
      WeeekTagName: "",
    }),
  );
};
/**Сохранить изменения в атрубетах weeek */
const saveСhangesAttributeWeeek = async () => {
  isLoading.value = true;
  switch (stateTabs.value) {
    case WeeekTabsEnum.Statuses:
      await upsertStatusesWeeek();
      break;
    case WeeekTabsEnum.Priorities:
      await upsertPrioritiesAsync();
      break;
    case WeeekTabsEnum.Types:
      await upsertTypesAsync();
      break;
    case WeeekTabsEnum.Tags:
      await upsertTagsAsync();
      break;
  }
  isLoading.value = false;
};
/**Добавить новый элемент в атрибуты weeek */
const addNewAttributeWeeek = () => {
  switch (stateTabs.value) {
    case WeeekTabsEnum.Statuses:
      addStatusesWeeek();
      break;
    case WeeekTabsEnum.Priorities:
      addPrioritiesWeeek();
      break;
    case WeeekTabsEnum.Types:
      addTypesWeeek();
      break;
    case WeeekTabsEnum.Tags:
      addTagsWeeek();
      break;
  }
};
/**Смена таба */
const changeTab = (tab: WeeekTabsEnum) => {
  stateTabs.value = tab;
  switch (tab) {
    case WeeekTabsEnum.SettingsToken:
      router.push({ name: WeeekTabsEnum.SettingsToken });
      break;
    case WeeekTabsEnum.Statuses:
      router.push({ name: WeeekTabsEnum.Statuses });
      break;
    case WeeekTabsEnum.Priorities:
      router.push({ name: WeeekTabsEnum.Priorities });
      break;
    case WeeekTabsEnum.Tags:
      router.push({ name: WeeekTabsEnum.Tags });
      break;
    case WeeekTabsEnum.Types:
      router.push({ name: WeeekTabsEnum.Types });
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Tabs), {
          modelValue: stateTabs.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((stateTabs).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), {
              label: "Настройки токена",
              val: _unref(WeeekTabsEnum).SettingsToken,
              currentTab: stateTabs.value,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(_unref(WeeekTabsEnum).SettingsToken)))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(KeyIcon), {
                  class: _normalizeClass(["key-icon", { 'key-icon-success': __props.isTokenLinked }])
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["val", "currentTab"]),
            _createVNode(_unref(Tab), {
              label: "Статусы",
              val: _unref(WeeekTabsEnum).Statuses,
              currentTab: stateTabs.value,
              class: _normalizeClass({ disabled: !__props.isTokenLinked }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(_unref(WeeekTabsEnum).Statuses)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(__props.dataWeeek.StatusesWeeek.length), 1)
              ]),
              _: 1
            }, 8, ["val", "currentTab", "class"]),
            _createVNode(_unref(Tab), {
              label: "Приоритеты",
              val: _unref(WeeekTabsEnum).Priorities,
              currentTab: stateTabs.value,
              class: _normalizeClass({ disabled: !__props.isTokenLinked }),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(_unref(WeeekTabsEnum).Priorities)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(__props.dataWeeek.PrioritiesWeeek.length), 1)
              ]),
              _: 1
            }, 8, ["val", "currentTab", "class"]),
            _createVNode(_unref(Tab), {
              label: "Типы",
              val: _unref(WeeekTabsEnum).Types,
              currentTab: stateTabs.value,
              class: _normalizeClass({ disabled: !__props.isTokenLinked }),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(_unref(WeeekTabsEnum).Types)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.dataWeeek.TypesWeeek.length), 1)
              ]),
              _: 1
            }, 8, ["val", "currentTab", "class"]),
            _createVNode(_unref(Tab), {
              label: "Теги",
              val: _unref(WeeekTabsEnum).Tags,
              currentTab: stateTabs.value,
              class: _normalizeClass({ disabled: !__props.isTokenLinked }),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(_unref(WeeekTabsEnum).Tags)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(__props.dataWeeek.TagsWeeek.length), 1),
                _createVNode(_unref(TirPmPopover), {
                  color: _unref(PopoverColorEnum).Black,
                  isTooltip: ""
                }, {
                  content: _withCtx(() => [
                    _createTextVNode("sdcscsdc")
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["val", "currentTab", "class"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (stateTabs.value !== _unref(WeeekTabsEnum).SettingsToken)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(TirPmButton), {
                variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                size: _unref(TirPmButtonSizeEnum).Middle,
                onClick: addNewAttributeWeeek
              }, {
                leftSlot: _withCtx(() => [
                  _createVNode(_unref(PlusIcon))
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Добавить ")
                ]),
                _: 1
              }, 8, ["variant", "size"]),
              (__props.changeDataWeeek)
                ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                    key: 0,
                    variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                    size: _unref(TirPmButtonSizeEnum).Middle,
                    isLoading: isLoading.value,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (saveСhangesAttributeWeeek()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Сохранить ")
                    ]),
                    _: 1
                  }, 8, ["variant", "size", "isLoading"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(RouterView), {
        projectId: __props.projectId,
        apiKey: __props.apiKey,
        dataWeeek: __props.dataWeeek,
        tagsProjectPm: __props.tagsProjectPm,
        onSearchTags: _cache[7] || (_cache[7] = ($event: any) => (emit('searchTags', $event))),
        onUpdateApiKey: _cache[8] || (_cache[8] = ($event: any) => (emit('updateApiKey', $event))),
        onUpdateProjectSettings: _cache[9] || (_cache[9] = ($event: any) => (emit('updateProjectSettings')))
      }, null, 8, ["projectId", "apiKey", "dataWeeek", "tagsProjectPm"])
    ]),
    _createVNode(_unref(TirPmModal), {
      isVisible: isVisibleModal.value,
      isWithBack: false,
      title: "Выйти сейчас?"
    }, {
      content: _withCtx(() => [
        _hoisted_7
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          onClick: hideModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Вернуться к редактированию ")
          ]),
          _: 1
        }, 8, ["variant"]),
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).LinkState,
          onClick: goDesiredRoute
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Выйти ")
          ]),
          _: 1
        }, 8, ["variant"])
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})